"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monteodorisio": {
    "f95c1ff2": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "colle-breccioli": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "29ab9dfe": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "colle-delle-querce": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c30f657f": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-defenza": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1376c5b1": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "giardino": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a8c91b9f": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "marracola": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "526c7b28": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "monteleforche": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f2f32ed4": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "mulino": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c3dc01e2": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "passo-della-carrozza": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "45dd6f51": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "piano-sinello": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2f77d580": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "pozzo-antico": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "00f53854": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "ripa": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "13aaee12": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "rivullo": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aac1d389": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "san-leonardo": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aca09b9e": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro-ad-aram": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3beb9c01": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "sant-anna": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5d1a47bb": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "tacconella": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2e1e1ff6": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "tratturo": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "865bef45": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "skipSearch": false
    }],
    "vallita": [{
      "hkey": "f15f5145",
      "slug": "monteodorisio",
      "name": "Monteodorisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;